import { Injectable } from '@angular/core';

declare var exec: any;
declare var execAsync: any;
declare var registerCallback: any;

@Injectable({
  providedIn: 'root'
})
export class AutocadIntegrationService {

  isAutoCADIntegrated: boolean = false;

  constructor() { 

  }

  async execAutoCAD(cromocadEvent: string) {
    console.log('AutoCAD event sent', cromocadEvent);
    try {
      const jsonResponse: string = exec(cromocadEvent);
      console.log(`CromoCad response -> `, jsonResponse);
      return jsonResponse;
    } catch (e) {
      if (e instanceof ReferenceError) {
        console.log(`ERROR: not using AutoCAD 2020`);
      } else {
        console.log(`ERROR: `, e);
      }
    }
    try {
      const jsonResponse: string = await execAsync(cromocadEvent);
      console.log(`CromoCad response -> `, jsonResponse);
      return jsonResponse;
    } catch (e) {
      if (e instanceof ReferenceError) {
        console.log(`ERROR: not using AutoCAD 2024`);
      } else {
        console.log(`ERROR: `, e);
      }
    }
    return;
  }

  setAutoCADIntegration(isIntegrated: boolean) {
    this.isAutoCADIntegrated = isIntegrated;
    console.log("Estado de integracion con AutoCAD: " + isIntegrated);
  }

  async setNoteId(noteId: number) {
    if (this.isAutoCADIntegrated) {
      let jsonResponse: string = await this.execAutoCAD(
        JSON.stringify({
          functionName: 'setNoteId',
          invokeAsCommand: false,
          functionParams: JSON.stringify(noteId)
        })
      );
      let objResponse: any = JSON.parse(jsonResponse);
      console.log(`Se notificó a CromoCAD el nuevo el ID de la nueva nota.`);
    } else {
      console.log(`El gestor de notas no se encuentra integrado con AutoCAD. No es necesario notificar el ID de la nota creada.`);
    }
  }

  public async getCurrentJWTToken(): Promise<any> {
    let response = new Promise<any>((resolve, reject) => {
      execAsync(
        JSON.stringify({
          functionName: "getCurrentJWTToken",
          invokeAsCommand: false,
          functionParams: null,
        }),
        (jsonResponse) => {
          const objResponse: any = JSON.parse(jsonResponse);
          resolve(objResponse.retValue);
        }
      )
    });
    return await response;
  }

  public async registerCallbackDownloads() {
    try {
      registerCallback('Ac_MessagingApi.callback', (event: string) => {
        const eventObj = JSON.parse(event);
        const payload = JSON.parse(eventObj.payload);
        this.openDownloadedFile(payload.obj.filePath);
      });
    } catch (ReferenceError) {
      console.log(`ERROR: No se pudo obtener el filePath del archivo`, ReferenceError);
    }
  }

  private openDownloadedFile(filePath: string) {
    let objRequest = {
      code: 'OPEN_DOWNLOADED_FILE',
      payload: {
        filePath: filePath
      }
    }
    let jsonRequest = JSON.stringify(objRequest);
    this.execAutoCAD(
      JSON.stringify({
        functionName: 'CROMOCAD_EVENT',
        functionParams: jsonRequest
      })
    );
  }
}
